<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex d-flex v-for="(unit, idx) in units" :key="idx" xs12 sm6 md4>
        <v-card dark class="elevation-10 ma-3">
          <v-card-title>
            {{unit.name}}
          </v-card-title>
          <v-card-text>
            Address: {{unit.address}}
          </v-card-text>
          <v-card-actions>
            <duo-unit-remove/>
            <duo-unit-edit :unit="unit"/>
            <v-spacer/>
            <duo-unit-invite :unit="unit"/>
            
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4>
        <v-card dark class="elevation-10 ma-3">
          <v-card-title>
            Empty
          </v-card-title>
          <v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <duo-unit-edit/>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from "vuex";
  import DuoUnitEdit from './DuoUnitEdit.vue'
  import DuoUnitRemove from './DuoUnitRemove.vue'
  import DuoUnitInvite from './DuoUnitInvite.vue'
  
  export default {
    components: {
      DuoUnitEdit,
      DuoUnitRemove,
      DuoUnitInvite
    },
    mounted() {
      this.$store.dispatch("duo/fetchDuo").then(() => {
        console.log("Loading Complete");
      });
    },
    computed: {
      ...mapState("duo", ["features", "units"])
    },
    methods: {
    },

    data() {
      return {
      }
    }
  }
</script>

<style>

</style>
